import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { config } from './config';
import { NumbersModel } from './models/numbers';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
		user : {},
		numbers: {
			daily: [],
			weekly: [],
			monthly: [],
			yearly: []
		}
	},
	
  mutations: {
	  auth_request(state){
			state.status = 'loading'
		},
		
	  auth_success(state, token, user){
			state.status = 'success'
			state.token = token
			state.user = user
		},
		
	  auth_error(state){
			state.status = 'error'
		},
		
	  logout(state){
			state.status = ''
			state.token = ''
		},
		
		numbers_daily(state, data) {
			state.numbers.daily = data
		},
		
		numbers_weekly(state, data) {
			state.numbers.weekly = data
		},

		numbers_monthly(state, data) {
			state.numbers.monthly = data
		},

		numbers_yearly(state, data) {
			state.numbers.yearly = data
		}
	},
	
  actions: {
		login({commit}, user){
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios({url: config.$api_url + '/oauth/token', data: user, method: 'POST' })
				.then(resp => {
					const token = resp.data.access_token
					const user = resp.data.user
					localStorage.setItem('token', token)
					axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
					commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					reject(err)
				})
			})
		},
		
		register({commit}, user){
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios({url: config.$api_url + '/register', data: user, method: 'POST' })
				.then(resp => {
					const token = resp.data.token
					const user = resp.data.user
					localStorage.setItem('token', token)
					axios.defaults.headers.common['Authorization'] = token
					commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					commit('auth_error', err)
					localStorage.removeItem('token')
					reject(err)
				})
			})
		},
		
		logout({commit}){
			return new Promise((resolve, reject) => {
				commit('logout')
				localStorage.removeItem('token')
				delete axios.defaults.headers.common['Authorization']
				resolve()
			})
		},

		getNumbers({commit}, payload) {
			return new Promise((resolve, reject) => {
				
				NumbersModel.getNumbers(payload.type, payload.id)
					.then(resp => {
						commit('numbers_' + payload.type, resp.data.numbers)
						resolve(resp)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

	  	setNumbers({ commit }, payload) {
			commit('numbers_' + payload.type, payload.data)
		}

	},
	
  getters : {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
		token: state => state.token,
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js